import { useQuery } from 'react-query';

import { queries } from '~/constants/queryKeys';
import { VinovestNetworkingHelper } from '~/helpers/VinovestNetworkingHelper';
import { useAuthentication } from '~/hooks/useAuthentication';

/** Query for fetching users Trading Portfolio */
export const useTradingPortfolioQuery = () => {
    const { isAuthenticated, userId } = useAuthentication();

    return useQuery(
        [queries.getTradingPortfolio, userId],
        async () => {
            const client = VinovestNetworkingHelper.getClient();

            const tradingPortfolioResponse = await client.managed.getTradingPortfolio();
            if (tradingPortfolioResponse) {
                const tradingPortfolioDetails = tradingPortfolioResponse.data;

                return {
                    ...tradingPortfolioDetails,
                    totalCashValue: tradingPortfolioDetails?.cash?.amount ?? 0
                };
            }
            return undefined;
        },
        {
            enabled: Boolean(isAuthenticated && userId)
        }
    );
};
